import { BaseCaseModel } from "@src/core/models/base";
import { ProductCatalog } from "./product-catalog";

export class SelectedProduct extends BaseCaseModel {
  id;
  customerId;
  productCatalog = new ProductCatalog();
}
